import { LoadingButton } from "@mui/lab";
import { Alert, Container, Grid, Paper, Snackbar, TextField, Typography } from "@mui/material";
import { setJwt } from "utils/jwt";
import Logo from "components/Logo";
import { useAuthenticationTokenCreate } from "queries/authentication_token";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const sessionExpired = () => new URLSearchParams(window.location.search).has("session_expired");

const LoginPage = () => {
  const { t } = useTranslation();
  const { mutateAsync: login, isLoading, isError } = useAuthenticationTokenCreate({ onSuccess: setJwt });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showSessionExpired, setShowSessionExpired] = useState(sessionExpired);

  return (
    <Container sx={{ pt: 12 }}>
      <Snackbar open={showSessionExpired} autoHideDuration={6000} onClose={() => setShowSessionExpired(false)}>
        <Alert severity="warning" sx={{ width: "100%" }}>
          {t("login.sessionExpired")}
        </Alert>
      </Snackbar>
      <Grid container mt={{ xs: 0, sm: 8 }} justifyContent="space-around">
        <Grid item xs={12} sm={5} pt={4}>
          <Logo variant="h3" />
          <Typography variant="subtitle1" fontSize="24px" lineHeight="32px">
            {t("login.headline")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={7} mt={2}>
          <Paper sx={{ p: 4, width: { xs: "auto", sm: "400px" } }}>
            <form
              onSubmit={async (e) => {
                e.preventDefault();
                await login({ username, password });
                window.location.reload();
              }}
            >
              {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {t("login.error")}
                </Alert>
              )}
              <Typography variant="body2" sx={{ mb: 2 }}>
                {t("login.requiredFieldsInfo")}
              </Typography>
              <TextField
                label={t("username")}
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                fullWidth
                autoComplete="username"
                helperText={t("login.usernameExample")}
                placeholder={t("login.usernamePlaceholder")}
                sx={{
                '.MuiInputBase-input': { fontSize: "1.15rem", color: "black", fontWeight: "Medium" },
                    }}
              />
              <TextField
                label={t("password")}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                fullWidth
                autoComplete="current-password"
                sx={{ mt: 3,'.MuiInputBase-input': { fontSize: "1.15rem", color: "black", fontWeight: "Medium" }, }}
              />
              <LoadingButton
                fullWidth
                size="large"
                variant="contained"
                sx={{ mt: 2 }}
                type="submit"
                loading={isLoading}
              >
                {t("connect")}
              </LoadingButton>
            </form>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default LoginPage;
